import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../ca-analysis-dialog.action';
import { CaAnalysisDialogState } from '../ca-analysis-dialog.state';

import { ReceiveResultData } from './receive-result-data.action';

export function receiveResultDataReducer(
    state: CaAnalysisDialogState,
    action: PayloadAction<
        ActionType.COACHING__CA__RECEIVE_RESULT_DATA,
        ReceiveResultData
    >,
): CaAnalysisDialogState {
    return {
        ...state,
        result: action.payload.caResult,
    };
}
